import { Injectable } from '@angular/core';
import { IProductDataV3, Product } from '@df/catalog/product/product';
import { BasketItem, basketItemFactory, IBasketItemData } from '@df/session/api/basket/basket-item';
import { Basket } from './basket';

@Injectable({ providedIn: 'root' })
export class BasketItemFactory {
    static beforeCreatePlugins: ((data: IBasketItemData, basket: Basket) => BasketItem<Product<IProductDataV3>> | void)[] = [];

    create(data: IBasketItemData, basket: Basket): BasketItem<Product<IProductDataV3>> {
        let item: BasketItem<Product<IProductDataV3>> | undefined;
        BasketItemFactory.beforeCreatePlugins.find(plugin => {
            item = plugin(data, basket) || undefined;
            return !!item;
        });

        return item || new basketItemFactory.instance(data, basket);
    }
}
